function cleanImageUrl(url) {
    return url.split('?')[0].split('#')[0]; 
}

document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function(){
  const firstContainer = document.querySelector("[data-first-video]");
  if (firstContainer) {
    const firstMedia = firstContainer.querySelector("video");
    if (firstMedia) {
      firstMedia.muted = true; 
      if (firstMedia.paused) {
        firstMedia.play()
          .then(() => 'play' )
          .catch(e => console.error("Autoplay failed:", e));
      }
    } 
  }
     }, 2000);
});


